import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card mb-5" }
const _hoisted_3 = { class: "card-body p-5" }
const _hoisted_4 = { class: "d-flex align-items-center mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-gray-800 mb-0 me-3" }, "月度真实净利润", -1)
const _hoisted_6 = { class: "row g-3" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "border border-gray-300 rounded p-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-7" }, "月毛利 (Profit 表)", -1)
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "border border-gray-300 rounded p-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-7" }, "月运营成本", -1)
const _hoisted_13 = { class: "fw-bolder fs-3 text-danger" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "border border-primary rounded p-4 bg-light-primary" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fs-7" }, "真实净利润 = 毛利 + 成本", -1)
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "border border-gray-300 rounded p-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-7 mb-1" }, "分类成本", -1)
const _hoisted_20 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_21 = { class: "text-danger" }
const _hoisted_22 = { class: "card-header card-header-stretch" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("新增成本")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7 mt-1" }, "⚠️ 必须为负数（支出统一负数；真实净利润 = 毛利 + 成本）", -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.summaryMonth,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.summaryMonth) = $event)),
            type: "month",
            placeholder: "选择月份",
            "value-format": "YYYY-MM",
            onChange: _ctx.refreshSummary
          }, null, 8, ["modelValue", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-3", _ctx.valueColor(_ctx.summary.profit_sum)])
              }, _toDisplayString(_ctx.formatMoney(_ctx.summary.profit_sum)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatMoney(_ctx.summary.total_cost)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-2", _ctx.valueColor(_ctx.summary.net_profit)])
              }, _toDisplayString(_ctx.formatMoney(_ctx.summary.net_profit)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              (!_ctx.byCategoryEntries.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, "本月无成本记录"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.byCategoryEntries, ([cat, amt]) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: cat,
                  class: "d-flex justify-content-between fs-7"
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.categoryLabel(cat)), 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatMoney(amt)), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.onSearch
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "button",
                status: "primary",
                onClick: _ctx.onNew
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "category",
            "item-render": {}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.category,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.category) = $event)),
                placeholder: "分类(全部)",
                clearable: "",
                style: {"width":"160px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryOptions, (opt) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: opt.value,
                      label: opt.label,
                      value: opt.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.duration,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.duration) = $event)),
                type: "daterange",
                "range-separator": " - ",
                "start-placeholder": "开始",
                "end-placeholder": "结束",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          field: "category",
          title: "分类",
          width: "140"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.categoryLabel(row.category)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "amount",
          title: "金额",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.valueColor(row.amount))
            }, _toDisplayString(_ctx.formatMoney(row.amount)), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "cost_date",
          title: "成本日期",
          width: "120"
        }),
        _createVNode(_component_vxe_column, {
          field: "note",
          title: "备注"
        }),
        _createVNode(_component_vxe_column, {
          field: "linkable",
          title: "关联单据",
          width: "180"
        }, {
          default: _withCtx(({ row }) => [
            (row.linkable_type)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(row.linkable_type) + "#" + _toDisplayString(row.linkable_id), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_27, "聚合录入"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "创建时间",
          width: "170"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "160"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_vxe_button, {
              type: "button",
              status: "primary",
              size: "mini",
              onClick: ($event: any) => (_ctx.onEdit(row))
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_vxe_button, {
              type: "button",
              status: "danger",
              size: "mini",
              onClick: ($event: any) => (_ctx.onDelete(row))
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: ['PrevJump','PrevPage','Number','NextPage','NextJump','Sizes','FullJump','Total'],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.dialogTitle,
      width: "520px",
      onClose: _ctx.onDialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_vxe_button, {
          type: "button",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_button, {
          type: "button",
          status: "primary",
          onClick: _ctx.onSave
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.dialog.id ? '保存' : '新增'), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.dialog,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "分类",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.dialog.category,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog.category) = $event)),
                  placeholder: "选择分类",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryOptions, (opt) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: opt.value,
                        label: opt.label,
                        value: opt.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "金额",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.dialog.amount,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialog.amount) = $event)),
                  max: -0.01,
                  step: 100,
                  precision: 2,
                  style: {"width":"100%"},
                  placeholder: "支出请填负数,如 -2300"
                }, null, 8, ["modelValue", "max"]),
                _hoisted_30
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "成本日期",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.dialog.cost_date,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialog.cost_date) = $event)),
                  type: "date",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "选择日期",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.dialog.note,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialog.note) = $event)),
                  type: "textarea",
                  rows: 2,
                  placeholder: "如：5月顺丰对账单 / 阿里云 ECS 月费"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onClose"])
  ]))
}